import { registerArchetype } from './index.js';
import { getRuntimes } from '../combat.js';
registerArchetype({
    id: 'ult_charge_on_hit',
    apply: ({ state, source, params }) => {
        const amount = params.amount ?? 5;
        const r = getRuntimes(state, source.side)[source.slot];
        r.statuses.push({
            id: `ult_charge_on_hit_${source.slot}`,
            kind: 'buff',
            remainingTicks: Number.MAX_SAFE_INTEGER,
            params: { ultChargeOnHit: amount }
        });
    }
});
